@import '~@fontsource/roboto/latin-ext.css';

* {
  font-family: 'Roboto', sans-serif;
}
[hidden] {
  visibility: hidden !important;
  opacity: 0 !important;
}
.full {
  /* position: absolute; */
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.container {
  width: 100%;
  height: 100%;
  background-color: white;
  max-width: 991px;
  margin: auto;
  position: relative;
  overflow: hidden;
}
.flex {
  display: flex;
}
.relative {
  position: relative;
}
.d-block {
  display: block;
}
.center {
  align-items: center;
  justify-content: center;
}
.footer {
  position: relative;
  width: 100%;
  margin-top: 5vh;
}
.w-100 {
  width: 100%;
}
.h-100 {
  height: 100%;
}

.px-1 {
  padding-left: 1em;
  padding-right: 1em;
}
.px-2 {
  padding-left: 2em;
  padding-right: 2em;
}
.px-3 {
  padding-left: 3em;
  padding-right: 3em;
}
.px-4 {
  padding-left: 4em;
  padding-right: 4em;
}
.py-1 {
  padding-top: 1em;
  padding-bottom: 1em;
}
.py-2 {
  padding-top: 2em;
  padding-bottom: 2em;
}
.py-3 {
  padding-top: 3em;
  padding-bottom: 3em;
}
.py-4 {
  padding-top: 4em;
  padding-bottom: 4em;
}
.mx-1 {
  margin-left: 1em;
  margin-right: 1em;
}
.mx-2 {
  margin-left: 2em;
  margin-right: 2em;
}
.mx-3 {
  margin-left: 3em;
  margin-right: 3em;
}
.mx-4 {
  margin-left: 4em;
  margin-right: 4em;
}
.my-1 {
  margin-top: 1em;
  margin-bottom: 1em;
}
.my-2 {
  margin-top: 2em;
  margin-bottom: 2em;
}
.my-3 {
  margin-top: 3em;
  margin-bottom: 3em;
}
.my-4 {
  margin-top: 4em;
  margin-bottom: 4em;
}
.ml-1 {
  margin-left: 1em;
}
.ml-2 {
  margin-left: 2em;
}
.ml-3 {
  margin-left: 3em;
}
.ml-4 {
  margin-left: 4em;
}
.mb-05 {
  margin-bottom: 0.5em;
}
.mb-1 {
  margin-bottom: 1em;
}
.mb-2 {
  margin-bottom: 2em;
}
.mb-3 {
  margin-bottom: 3em;
}
.mb-4 {
  margin-bottom: 4em;
}
.mt-05 {
  margin-top: 0.5em;
}
.mt-1 {
  margin-top: 1em;
}
.mt-2 {
  margin-top: 2em;
}
.mt-3 {
  margin-top: 3em;
}
.mt-4 {
  margin-top: 4em;
}

h1 {
  color: #252c82;
  font-size: 1.5em;
  margin: 0;
}
h2 {
  font-weight: 500;
  font-size: 1.2em;
  margin: 0;
  color: #525252;
}
h3 {
  font-size: 1.4em;
  margin: 0;
}
.main-text {
  font-weight: 400;
  color: #525252;
}
.link-text {
  text-decoration: underline;
  color: #252c82d9;
}
.rounded {
  border-radius: 8px;
}
.cit-selector {
  width: 50%;
}
.img-text {
  display: flex;
  align-items: center;
}
.img-text .bg-img {
  width: 4em;
  height: 5em;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  margin-right: 1em;
}
.button {
  position: relative;
}
.img-loader {
  position: absolute;
  left: -2px;
  top: -2px;
  background: #ffffffc7;
  border: 2px solid #252c82;
  box-shadow: 3px 3px 6px #00000029;
}
.img-loader.rounded {
  border-radius: 11px;
}
.img-loader-button {
  width: 100%;
  height: 100%;
}
.img-loader-button.rounded {
  border-radius: 50px;
}
.loading-image-button {
  width: 100%;
  height: 100%;
  border-radius: 25px;
}
.main-button {
  background: #7bb40e;
  border-radius: 50px;
  text-align: center;
  width: 100%;
  padding: 0.9em;
  color: #fff;
  border: 0;
  font-size: 1.1em;
  font-weight: 600;
}
.main-button:disabled {
  color: #fff;
  background: #bdbdbd;
}
.color-red {
  color: #ff5353;
}
.color-blue {
  color: #252c82;
}
.loud-text {
  font-size: 1.2em;
}
.loud-text p {
  margin: 0.6em 0;
}
.modal {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  background: #8b8b8be0;
  visibility: visible;
  opacity: 1;
  transition: visibility 0s, opacity 0.2s linear;
}
.inner {
  background: white;
  box-shadow: 3px 3px 6px #00000029;
  border-radius: 10px;
  padding: 2em;
  position: relative;
}
.close-modal {
  position: absolute;
  top: 1em;
  right: 1em;
}
.document-view {
  height: 100%;
}
.scroll {
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  scroll-behavior: smooth;
  position: relative;
}
.scroll:before {
  content: '';
  display: block;
  width: 100%;
  height: 15px;
  position: sticky;
  top: 0;
  left: 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
}
.scroll:after {
  content: '';
  display: block;
  width: 100%;
  height: 15px;
  position: sticky;
  bottom: 0;
  left: 0;
  background: linear-gradient(0deg, rgba(255, 255, 255, 1) 0%, rgba(255, 255, 255, 0) 100%);
}
.main-input {
  width: calc(100% - 3.2em - 2px);
  padding: 0.8em 1.6em;
  border: 2px solid #464e58;
  font-size: 1.2em;
  border-radius: 10px;
}
.checklist ul {
  margin: 0;
  padding-left: 20px;
  text-align: left;
  list-style-image: url('assets/checkmark.svg');
}
.checklist li {
  margin-bottom: 1em;
}
.checklist li:last-child {
  margin-bottom: 0;
}

.row-validare h1 {
  font-size: 28px;
  line-height: 32px;
}

body {
  margin: 0;
  padding: 0;
  height: 100vh;
  position: relative;
  height: 100vh;
  /*height: calc(var(--vh, 1vh) * 100);*/
  /*margin: 0 auto;*/
  /*max-width: 100%;*/
}

.container-video {
  height: 99vh;
  text-align: center;
  position: relative;
  overflow: hidden;
}
.row {
  padding: 3.5vh 2.5vh;
  height: 100%;
  overflow: hidden;
  position: relative;
  /*display: flex;*/
  /*align-items: center;*/
}
.ctheight-100 {
  height: 99vh;
}
.d-flex {
  display: flex;
}
.space-between {
  justify-content: space-between;
}
.img-info img {
  width: 0.8vh;
  z-index: 5;
  position: relative;
}
.img-info {
  width: 7vh;
  height: 7vh;
  border-radius: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: radial-gradient(100% 100% at 50% 0%, #d3b6e9 0%, #fbc2bd 100%);
}
.i-effect {
  animation: 2.5s infinite transition-i;
  position: absolute;
  z-index: 2;
  border-radius: 100%;
  background: radial-gradient(100% 100% at 50% 0%, #d3b6e9 0%, #fbc2bd 100%);
}
.two-buttons {
  margin-top: 3vh;
  justify-content: center;
}
.align-center {
  align-items: center;
}

.font-size-2 {
  font-size: 2vh;
}
.row-validare .font-size-2 {
  font-size: 17px;
  line-height: 19px;
}

.img-text .bg-img img {
  width: 100%;
  padding: 2vh;
}

.cit-selector-desktop {
  width: 200px;
  height: 140px;
}
.img-selector {
  width: 100%;
}

.img-text .cit-selector,
.img-text .cit-selector-desktop {
  border-radius: 5%;
}
.img-text h3 {
  color: #333333;
  font-weight: 700;
  font-size: 2.3vh;
  margin: 0;
}

.font-weight-bold {
  font-weight: bold;
}
.font-size-18 {
  font-size: 1.8vh;
}
.row-validare .font-size-18 {
  font-size: 15px;
  line-height: 16px;
}
a {
  font-size: inherit;
  color: inherit;
  text-decoration: none;
}
.color-black {
  color: #000;
}

.normal-button {
  background: #1feaa6;
  box-shadow: 0 6px 8px rgba(71, 182, 162, 0.2);
  border-radius: 25px;
  text-align: center;
  padding: 2vh;
  margin-right: 1vw;
  margin-left: 1vw;
  color: #fff;
  border: 0;
  font-size: 2vh;
}
.red-button {
  background: #ff535d;
}
.row-validare .main-button {
  font-size: 17px;
}
.text-right {
  text-align: right;
}

.mb-0 {
  margin-bottom: 0;
}
.row-validare.row {
  padding: 29px 21px;
}
.row-validare .main-button {
  padding: 16px;
}
.row-validare .btn-buletin {
  position: relative;
  width: 100%;
  bottom: 0;
}
.show-bottom {
  bottom: -2vh;
}
.second-input {
  width: 46px;
  height: 46px;
  font-weight: 700;
  font-size: 16px;
  font-family: 'Inter', sans-serif;
  text-align: center;
  border: 2px solid #c5c6cc;
  border-radius: 12px;
  outline: none;
  padding: 2px;
}
.second-input:not(:placeholder-shown) {
  border: 2px solid #1feaa6;
  color: #1feaa6;
}
.mt-9 {
  margin-top: 9%;
}
.second-input::placeholder {
  color: #fff;
  opacity: 0;
}
.second-input:focus {
  border: 2px solid #464e58;
  color: #464e58;
}
.second-input.error {
  border: 2px solid #b67171;
}
.second-input.error:focus {
  border: 3px solid #b67171;
  color: #b67171;
  padding: 1px;
}
.second-input.error:not(:placeholder-shown) {
  border: 3px solid #b67171;
  color: #b67171;
  padding: 2px;
}
.second-input-container {
  margin-top: 30%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.input-container {
  display: flex;
  flex-wrap: wrap;
}
.mt-15 {
  margin-top: 15%;
}
.row-validare .mt-15 {
  margin-top: 40px;
}
.mb-15 {
  margin-bottom: 15%;
}
.row-validare .mb-15 {
  margin-bottom: 40px;
}
.mb-20 {
  margin-bottom: 20%;
}
.row-validare .mb-1 {
  margin-bottom: 20px;
}
.row-validare .mb-20 {
  margin-bottom: 60px;
}
.mt-90 {
  margin-top: 90px;
}
.op-05 {
  opacity: 0.5;
}

.error-text {
  position: relative;
  top: 50px;
  margin-bottom: 0;
  margin-top: 0;
}
.top-50 {
  top: 50px;
}
.mt-25 {
  margin-top: 25%;
}
.text-center {
  text-align: center;
}
.scale-2 {
  transform: scale(2);
}
.mt-20 {
  margin-top: 20%;
}
.div-ci img {
  max-height: 40vh;
  max-width: 80vw;
}
.div-ci {
  text-align: center;
}
.mt-10 {
  margin-top: 10vh;
}
.mt-5 {
  margin-top: 5vh;
}
.pos-relative {
  position: relative;
}

.pos-absolute {
  position: absolute;
}
.btn-buletin {
  text-align: center;
}
.buletin-container img {
  width: 60%;
}
.buletin-container > img {
  margin-top: 10vh;
}
.buletin-container {
  text-align: center;
}
.color-white {
  color: #fff;
}
.chenar-buletin {
  margin-top: 3em;
  text-align: center;
}
.chenar-buletin .ci-img {
  width: 96%;
}
.chenar-buletin .face-img,
.chenar-buletin .chenar-img {
  left: 4%;
  width: 92%;
  top: -20px;
  min-height: 55vw;
  display: flex;
  position: absolute;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.2);
  justify-content: center;
}
.chenar-buletin img {
  width: auto;
  height: 100%;
  top: 0;
  left: 0;
  position: absolute;
  border-radius: 10px;
  z-index: 4;
}
.chenar-buletin .face-img {
  background-color: rgba(255, 255, 255, 0.3);
}
.buletin-container .w-40 {
  width: 40%;
}
.animation {
  width: 100%;
  height: 100%;
  /* opacity: 60%; */
}
.color-black-2 {
  color: #71727a;
}
.font-size-3 {
  font-size: 3vh;
}
.font-size-25 {
  font-size: 2.5vh;
}
.font-size-1 {
  font-size: 1vh;
}
.font-weight-900 {
  font-weight: 900;
}
.mt-8 {
  margin-top: 8vh;
}
.mt-12 {
  margin-top: 12vh;
}
.mt-30-i {
  margin-top: 30% !important;
}
.ml-5 {
  margin-left: 5vh;
}
.chenar-buletin .face-img {
  left: -2%;
  width: 104%;
  top: -40px;
}
.pl-2-5 {
  padding-left: 2.5vh;
}
.container-coin {
  background-color: transparent;
  perspective: 1000px;
  rotate: 120deg 0deg;
}
.coin-flip {
  animation: flip 0.4s ease-in;
  animation-delay: 0.5s;
  transform-style: preserve-3d;
  animation-fill-mode: forwards;
  visibility: hidden;
}

.coin-scale {
  animation: show 0.4s ease-in;
  animation-delay: 0.5s;
  transform-style: preserve-3d;
  animation-fill-mode: forwards;
}

.scroll-disabled {
  height: 100%;
  overflow-x: hidden;
  pointer-events: none;
  user-select: none;
}

.scroll-to-top-btn {
  position: fixed;
  z-index: 200;
  bottom: 20px;
  left: 20px;
  width: 6vh;
  height: 6vh;
  border-radius: 50%;
  background-color: #1feaa6;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 5vh;
  cursor: pointer;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.3);
  transition: background-color 0.3s;
}

.scroll-to-top-btn:hover {
  background-color: #17d296;
}

.scroll-full {
  margin: 4px, 4px;
  padding: 4px;
  overflow-x: hidden;
  overflow-y: auto;
}

.video-demo {
  z-index: 0;
  width: 100%;
  height: 100%;
  border-radius: 20px;
}

.video-capture {
  padding: 2.5vh 2.5vh;
  margin-top: 3em;
  text-align: center;
  position: relative;
}

.capture-title {
  z-index: 4;
  margin-top: 3vh;
  position: absolute;
  bottom: 5vh;
  padding: 2.5vh 2.5vh;
}

video::-webkit-media-controls {
  display: none !important;
}

@keyframes transition-i {
  from {
    width: 0;
    height: 0;
    opacity: 1;
  }
  80% {
    width: 10vh;
    height: 10vh;
    opacity: 0.5;
  }
  100% {
    opacity: 0;
  }
}
@keyframes flip {
  0% {
    transform: rotateX(140deg);
    visibility: visible;
  }

  25% {
    transform: rotateX(120deg);
    visibility: visible;
  }

  50% {
    transform: rotateX(90deg);
    visibility: visible;
  }

  75% {
    transform: rotateX(75deg);
    visibility: visible;
  }

  100% {
    transform: rotateX(0deg);
    visibility: visible;
  }
}

@keyframes show {
  0% {
    transform: scale(0);
  }

  25% {
    transform: scale(0.2);
  }

  40% {
    transform: scale(0.4);
  }

  50% {
    transform: scale(0.5);
  }

  60% {
    transform: scale(0.6);
  }

  70% {
    transform: scale(0.7);
  }

  100% {
    transform: scale(1);
  }
}
@keyframes rise {
  0% {
    visibility: hidden;
  }

  50% {
    visibility: visible;
  }

  100% {
    visibility: visible;
  }
}
.buletin-container.rotate-x img {
  animation: transform-rotate-x 2s infinite ease-in;
}
.rotateimg90 {
  animation: transform-rotate-x2 2s forwards;
  animation-delay: 1s;
  position: absolute;
}
.rotateimg180 {
  animation: transform-rotate-x3 2s forwards;
  animation-delay: 3s;
  position: absolute;
  opacity: 0;
}
.buletin-back {
  display: flex;
  justify-content: center;
}

.pulsate {
  animation: textPulse 2s ease 0s infinite normal forwards;
}

@keyframes textPulse {
  0% {
    transform: scale(1);
  }

  50% {
    transform: scale(1.1);
  }

  100% {
    transform: scale(1);
  }
}

@keyframes transform-rotate-x3 {
  from {
    transform: rotateY(-90deg);
    opacity: 1;
  }
  to {
    transform: rotateY(0deg);
    opacity: 1;
  }
}
@keyframes transform-rotate-x2 {
  to {
    transform: rotateY(90deg);
  }
}
@keyframes transform-rotate-x {
  to {
    transform: perspective(600px) rotateX(40deg);
  }
}
@media only screen and (max-width: 350px) {
  .second-input {
    width: 36px;
    height: 36px;
  }
}
@media only screen and (max-width: 390px) {
  .second-input {
    width: 40px;
    height: 40px;
  }

  .ml-5 {
    margin-left: 20vw;
  }
}

@media only screen and (min-width: 530px) and (max-width: 767px) {
  .chenar-buletin .face-img {
    width: 70%;
    min-height: auto;
    margin: auto;
    left: 15%;
    right: auto;
    top: -15vh;
  }

  .ml-5 {
    margin-left: 15vw;
  }
}
@media only screen and (min-width: 600px) and (max-width: 767px) {
  .max-h img {
    margin-left: 15%;
    margin-right: 15%;
  }
  .max-h {
    display: flex;
    align-items: center;
  }

  .ml-5 {
    margin-left: 10vw;
  }
}
@media only screen and (max-width: 991px) {
  .buletin-container img {
    max-width: 220px;
  }

  .ml-5 {
    margin-left: 2.5vw;
  }
}
@media only screen and (min-width: 767px) {
  .container {
    max-width: 530px;
    margin: 40px auto;
    border-radius: 20px;
    box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.1);
    height: calc(100% - 80px);
  }
  body {
    height: 90vh;
  }
  .btn-buletin {
    max-width: 490px;
    bottom: 7vh;
  }
  .buletin-container img {
    width: 45%;
  }
  .chenar-buletin .face-img,
  .chenar-buletin .chenar-img {
    min-height: 300px;
  }
  .chenar-buletin .face-img {
    width: 80%;
    min-height: auto;
    margin: auto;
    left: 10%;
    right: auto;
    top: -10vh;
  }

  .img-selector {
    width: 10vw;
  }
}

.loader-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 1.5rem;
  z-index: 1000;
  border-radius: 10px;
}

.loader-spinner {
  border: 8px solid #71727a; /* Light grey */
  border-top: 8px solid #1feaa6;
  border-radius: 50%;
  width: 60px;
  height: 60px;
  animation: spin 2s linear infinite;
  margin-bottom: 20px;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
